<template>
  <div id="todoList">
    <div class="title">
      <img src="../../assets/image/icon_zzjj@2x.png" alt />
      <h3>我的备忘</h3>
    </div>
    <div class="tableContainer">
      <el-tabs v-model="organizationActive" @tab-click="handleClick">
        <!-- 项目类型 -->
        <el-tab-pane label="我的备忘" name="1">
          <div class="searchRow">
            <el-button class="creat" style="background-color:#40A0F2;" @click="addUserClick">新建</el-button>
          </div>
          <div class="knowledgeHisTable">
            <ul class="table__body" v-if="tableData.length>0">
              <li
                class="tableBodyItem"
                v-for="item in tableData"
                :key="item.project_id"
                @click="showDetails(item)"
              >
                <div class="itemleft">
                  <h3 class="projectItemTitle" :title="item.content">
                    <!-- <span class="starIcon" ></span> -->
                    {{item.content}}
                  </h3>
                </div>
                <div class="itemRight">
                  <span style="margin-right:30px">{{item.add_time}}</span>
                  <!-- 下按钮 -->
                  <el-button class="checkBtn" @click.stop="handleEditClass(item)">编辑</el-button>
                  <el-button class="checkBtn removeBtn" @click.stop="handleRemoveClass(item)">删除</el-button>
                </div>
              </li>
            </ul>
            <div v-else class="emptyImg table__body">
              <p style="color:#909399;text-align:center;margin-top:10vh">暂无数据</p>
            </div>
            <div class="pageRow" v-if="tableData.length>0">
              <el-pagination
                @size-change="handleUserSizeChange"
                @current-change="handleUserCurrentChange"
                :current-page="currentUserPage"
                :page-sizes="[5, 10, 15, 20, 30]"
                :page-size="userPageSize"
                background
                layout="total, sizes, prev, pager, next, jumper"
                :total="Total"
              ></el-pagination>
            </div>
          </div>
        </el-tab-pane>
      </el-tabs>
    </div>
    <el-dialog
      :visible.sync="dialogVisible"
      width="50%"
      :before-close="handleClose"
      @close="handleClosed"
      v-dialogDrag
    >
      <div slot="title" class="header-title">
        <span
          class="title-name"
          v-if="showForm=='2-edit'"
          style="color:#128BF1;margin-right:5px"
        >张某某</span>
        <span class="title-age" v-if="showForm=='1'">新增备忘</span>
        <span class="title-age" v-if="showForm=='1-edit'">编辑备忘</span>
      </div>
      <div class="diaContainer">
        <!-- 编辑项目类型 -->
        <el-form ref="form" :model="editUserForm" label-width="30%" v-if="showForm=='1-edit'">
          <el-form-item label="内容">
            <el-input type="textarea" placeholder="请输入内容" v-model="editUserForm.content"></el-input>
          </el-form-item>
        </el-form>
        <!-- 新增项目类型 -->
        <el-form ref="form" :model="addUserForm" label-width="30%" v-if="showForm=='1'">
          <el-form-item label="内容">
            <el-input type="textarea" placeholder="请输入内容" v-model="addUserForm.content"></el-input>
          </el-form-item>
        </el-form>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button style="background-color: #ccc;" @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" :disabled="addFlag" @click="DiaClick">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
export default {
  data() {
    return {
      addFlag: false,
      showForm: '',
      organizationActive: '1',
      searchInfo1: '',
      searchInfo2: '',
      searchInfo3: '',
      currentUserPage: 1,
      userPageSize: 10,

      currentPage1: 1,
      pageSize1: 10,
      Total: 0,
      currentPage2: 1,
      pageSize2: 10,
      total2: 0,
      currentPage3: 1,
      pageSize3: 10,
      total3: 0,

      editClassName: '',
      editClassId: '',

      token: '',
      member_id: '',
      company_id: '',
      cache_department_id: '',
      userTotal: 0,
      dialogVisible: false,
      // 新增成员
      addUserForm: {
        name: '',
        chargePeople: '',
        status: '1',
        isCharge: '1',
        isAn: '1',
        isFreeze: '1',
      },

      editUserId: '',
      // 新增部门表单
      addClassForm: {
        pte_name: '',
        pte_abbreviation: '',
      },
      editClassForm: {
        pte_name: '',
        pte_abbreviation: '',
      },

      addUserForm: {
        content: '',
      },
      editUserForm: {
        content: '',
      },

      tableData: [],
    }
  },
  methods: {
    DiaClick() {
      if (this.showForm === '1-edit') {
        // 编辑成员
        this.editClassFormSubmit()
      } else if (this.showForm === '1') {
        // 编辑成员
        this.addClassFormSubmit()
      }
    },
    // *删除部门
    async handleRemoveClass(row) {
      const isDelete = await this.$confirm('是否删除', {
        confirmButtonText: '是',
        cancelButtonText: '否',
        type: 'warning',
      }).catch((error) => error)
      // 如果用户点记得是取消操作
      if (isDelete === 'cancel') return this.$message('取消删除操作')
      // 如果用户点击的是删除
      if (isDelete === 'confirm') {
        // 发送删除请求
        let param = new URLSearchParams()
        param.append('member_id', this.member_id)
        param.append('token', this.token)
        if (this.$store.state.process.app.deviceInfo) {
          param.append('device', this.$store.state.process.app.deviceInfo)
        } else {
          param.append('device', 'pc')
        }
        param.append('cache_department_id', this.cache_department_id)
        param.append('company_id', this.company_id)
        param.append('note_id', row.id)
        const { data: res } = await this.$axios({
          method: 'post',
          url: '/api/Notes/del',
          data: param,
        })
        if (res.code != 200) return this.$message.error(res.datas.msg)
        this.$message.success(res.datas.msg)
        this.getTodeList()
      }
    },

    // *点击编辑部门
    async handleEditClass(row) {
      this.showForm = '1-edit'
      this.editUserForm.content = row.content
      this.editClassId = row.id
      this.dialogVisible = true
    },
    // *编辑部门提交
    async editClassFormSubmit() {
      let param = new URLSearchParams()
      param.append('member_id', this.member_id)
      param.append('token', this.token)
      if (this.$store.state.process.app.deviceInfo) {
        param.append('device', this.$store.state.process.app.deviceInfo)
      } else {
        param.append('device', 'pc')
      }
      param.append('cache_department_id', this.cache_department_id)
      param.append('company_id', this.company_id)
      param.append('note_id', this.editClassId)

      param.append('content', this.editUserForm.content)
      const { data: res } = await this.$axios({
        method: 'post',
        url: '/api/Notes/edit',
        data: param,
      })
      if (res.code != 200) return this.$message.error(res.datas.msg)
      this.$message.success(res.datas.msg)
      this.dialogVisible = false
      this.getTodeList()
    },
    // *新增部门提交
    async addClassFormSubmit() {
      let param = new URLSearchParams()
      param.append('member_id', this.member_id)
      param.append('token', this.token)
      if (this.$store.state.process.app.deviceInfo) {
        param.append('device', this.$store.state.process.app.deviceInfo)
      } else {
        param.append('device', 'pc')
      }
      param.append('cache_department_id', this.cache_department_id)
      param.append('company_id', this.company_id)

      param.append('content', this.addUserForm.content)
      const { data: res } = await this.$axios({
        method: 'post',
        url: '/api/Notes/add',
        data: param,
      })
      if (res.code != 200) return this.$message.error(res.datas.msg)
      this.$message.success(res.datas.msg)
      this.dialogVisible = false
      this.getTodeList()
    },
    // *获取部门列表
    async getTodeList() {
      let param = new URLSearchParams()
      param.append('member_id', this.member_id)
      param.append('token', this.token)
      if (this.$store.state.process.app.deviceInfo) {
        param.append('device', this.$store.state.process.app.deviceInfo)
      } else {
        param.append('device', 'pc')
      }
      param.append('cache_department_id', this.cache_department_id)
      param.append('company_id', this.company_id)
      param.append('p', this.currentUserPage)
      param.append('p_count', this.userPageSize)
      const { data: res } = await this.$axios({
        method: 'post',
        url: '/api/Notes/index',
        data: param,
      })
      if (res.code != 200) return this.$message.error(res.datas.msg)

      this.tableData = res.datas.listInfo
      this.Total = parseInt(res.datas.count)
      console.log('评价类型列表', this.tableData2)
    },
    // 点击新增成员
    addUserClick() {
      this.showForm = '1'
      this.dialogVisible = true
    },

    handleClick(tab, event) {
      console.log(tab, event)
    },
    handleUserSizeChange(val) {
      this.userPageSize = val
      this.getTodeList()
    },
    handleUserCurrentChange(val) {
      this.currentUserPage = val
      this.getTodeList()
    },

    handleClose(done) {
      this.dialogVisible = false
    },
    handleClosed() {
      this.addUserForm.content = ''
      this.editClassId = ''
      this.editUserId = ''
      this.addFlag = false
    },
  },
  created() {
    this.token = localStorage.getItem('btlh_process_token') || ''
    this.member_id = localStorage.getItem('btlh_process_member_id') || ''
    this.company_id = localStorage.getItem('bthl_process_LoginCompanyId') || ''
    this.cache_department_id =
      localStorage.getItem('bthl_process_cache_department_id_store') || ''
    if (!this.company_id) {
      this.$message.error('请重新选择您要进入的企业')
      this.$router.push('/join')
    }
    this.getTodeList()
  },
}
</script>
<style lang="less" scoped>
#todoList {
  width: 100%;
  height: 92%;
  box-sizing: border-box;
  padding: 0 3.5%;
  .title {
    display: flex;
    align-items: center;
    padding: 30px 0 20px;
    img {
      display: block;
      width: 31px;
      margin-right: 20px;
    }
    h3 {
      font-size: 28px;
      font-weight: 400;
      color: #333;
    }
  }
  // 表格主体
  .tableContainer {
    width: 100%;
    border-radius: 10px;
    height: calc(100% - 90px - 30px);
    background-color: #fff;
    box-sizing: border-box;
    padding: 0 40px;
    padding-top: 20px;
    // 搜索行
    .searchRow {
      display: flex;
      align-items: center;
      justify-content: flex-end;
      width: 100%;
      /deep/.el-button {
        font-size: 18px;
        font-weight: normal;
        border: none;
        width: 130px;
        height: 45px;
        background: #f4a029;
        color: #fff;
        border-radius: 24px;
        padding: 0;
        margin-left: 30px;
      }
    }
    /deep/.tableSearch {
      width: 28%;
      // (deep)
      .el-input__inner {
        height: 48px;
        border-radius: 24px;
        font-size: 16px;
        border: none;
        background-color: #f4f5f6;
      }
    }

    /deep/.el-table__header {
      box-sizing: border-box;
      th {
        border-color: #40a0f2 !important;
      }
      .gutter {
        background-color: #40a0f2;
      }
    }
    // 分页行
    .pageRow {
      box-sizing: border-box;
      padding-top: 10px;
      width: 100%;
      height: 50px;
      display: flex;
      align-items: center;
      justify-content: flex-end;
      /deep/.el-pagination .el-select .el-input .el-input__inner {
        font-size: 14px;
      }
      /deep/.el-pagination button,
      /deep/.el-pagination span:not([class*='suffix']) {
        font-size: 14px;
      }
    }
    // 表格行
    /deep/.el-table__body {
      width: 100% !important;
    }
    .el-table::before {
      display: none;
    }
    /deep/.el-table__body-wrapper {
      box-sizing: border-box;
      border: 1px solid #f4f5f6;
    }
    // 鼠标经过效果
    /deep/.el-table--enable-row-hover .el-table__body tr:hover > td {
      background-color: #eff8ff;
    }
    // 斑马颜色
    /deep/.el-table--striped .el-table__body tr.el-table__row--striped td {
      background-color: #f4f5f6;
    }
    // 滚动条的宽度
    /deep/ .el-table__body-wrapper::-webkit-scrollbar {
      // position: absolute;
      // bottom: 0;
      width: 6px; // 横向滚动条
      height: 5px; // 纵向滚动条 必写
    }
    // 滚动条的滑块
    /deep/ .el-table__body-wrapper::-webkit-scrollbar-thumb {
      background-color: #ddd;
      border-radius: 3px;
    }
    // 滚动条的滑块
    /deep/ .el-table__body-wrapper::-webkit-scrollbar-thumb:hover {
      background-color: #ccc;
    }
    // *修改tabs样式
    /deep/.el-tabs__active-bar {
      width: 60px !important;
      margin-left: 30px;
    }
    /deep/.el-tabs {
      width: 100%;
      height: 100%;
      .el-tabs__header {
        width: 100%;
        margin-bottom: 20px;
        .el-tabs__nav-wrap {
          width: 100%;
          .el-tabs__nav-scroll {
            width: 100%;
            .el-tabs__nav {
              box-sizing: border-box;
              padding-left: 20px;
              width: 100%;
            }
          }
        }
      }
      .el-tabs__content {
        height: calc(100% - 80px);
        .el-tab-pane {
          height: 100%;
        }
      }
    }
    /deep/.el-tabs__item {
      height: 60px;
      text-align: center;
      font-size: 20px;
      color: #999999;
      font-weight: 400;
      padding-right: 180px;
      // width: 17%;
    }
    /deep/.el-tabs__item.is-active {
      color: #333 !important;
    }
    /deep/.el-tabs__item:hover {
      color: #333 !important;
    }
    /deep/.el-tabs__nav-wrap::after {
      color: #999999;
    }
    // 修改tabs样式
  }
  // 表格操作按钮
  .tableBtn {
    padding: 0;
    // display: flex;
    justify-content: center;
    width: 80px;
    height: 32px;
    border-color: #40a0f2;
    color: #0099ff;
    border-radius: 5px;
    font-weight: normal;
  }
  // dialog弹窗
  /deep/.el-dialog {
    border-radius: 10px;
    .el-dialog__header {
      border-radius: 10px 10px 0 0;
      background-color: #f4f5f6;
      font-size: 20px;
      color: #333;
      padding-top: 20px;
      padding-bottom: 20px;
      padding-left: 40px;
    }
  }
  // 修改dia尾部按钮样式
  .dialog-footer {
    width: 100%;
    display: flex;
    padding-left: 30%;
    .el-button {
      // width: 180px;
      width: 23%;
      height: 50px;
      padding: 0;
      font-size: 20px;
      font-weight: normal;
      color: #fff;
      border: none;
      border-radius: 25px;
      background-color: #40a0f2;
      margin-bottom: 40px;
    }
    .el-button:first-child {
      margin-right: 5%;
    }
  }

  // 修改表单label
  /deep/.el-form-item__label {
    font-size: 16px;
    color: #333;
    box-sizing: border-box;
    padding-right: 50px;
    line-height: 40px;
  }
  // 修改内容
  /deep/.el-form-item__content {
    display: flex;
    // (deep)
    .el-select {
      width: 100%;
      .el-input {
        width: 80%;
      }
      .el-input__inner {
        width: 100%;
        font-size: 18px;
      }
    }
    .el-input__inner {
      font-size: 18px;
      width: 80%;
      height: 56px;
      border-radius: 0;
    }
    .el-textarea {
      width: 80%;
      .el-textarea__inner {
        height: 250px;
        font-size: inherit;
        font-family: Microsoft YaHei;
        resize: none;
        border-radius: 0;
      }
    }
    .el-radio-group {
      height: 56px;
      width: 100%;
      display: flex;
      align-items: center;
      .el-radio {
        display: flex;
        align-items: center;
        margin-right: 15%;
      }
      .el-radio__input {
        width: 18px;
        height: 18px;
        .el-radio__inner {
          width: 18px;
          height: 18px;
        }
      }
      .el-radio__label {
        font-size: 18px;
      }
    }
  }
  // 修改下啦
  /deep/.classChargePeople {
    width: 160px !important;
    min-width: 160px !important;
    margin-left: 18%;
  }
  .knowledgeHisTable {
    width: 100%;
    height: 61vh;
    box-sizing: border-box;
    padding-top: 3px;
    .table__body {
      box-sizing: border-box;
      height: calc(100% - 60px);
      width: 100%;
      overflow-y: auto;
      padding: 0 2px;
      // li
      .tableBodyItem {
        cursor: pointer;
        box-sizing: border-box;
        padding: 20px 40px;
        border-bottom: 1px solid #ebebeb;
        width: 100%;
        display: flex;
        justify-content: space-between;
        .starIcon {
          display: none;
        }
        .itemleft {
          font-size: 16px;
          color: #999999;
          .projectItemTitle {
            max-width: 600px;
            overflow: hidden; /*超出部分隐藏*/
            white-space: nowrap; /*不换行*/
            text-overflow: ellipsis; /*超出部分文字以...显示*/
            font-size: 20px;
            font-weight: normal;
            color: #333;
          }
        }
        .itemRight {
          display: flex;
          align-items: center;
          /deep/.checkBtn {
            color: #0099ff;
            border-color: #0099ff;
            font-weight: normal;
            padding: 0 22px;
            height: 32px;
          }
          .removeBtn {
            color: #ff1a1a;
            border-color: #ff1a1a;
          }
        }
        // 知识库-列表创建人下拉框
        .moreDrop {
          position: relative;
          .dropBody {
            position: absolute;
            left: -340px;
            top: -10px;
            z-index: 99;
            background: rgba(255, 255, 255, 1);
            box-shadow: 0px 0px 4px 1px rgba(0, 0, 0, 0.11);
            box-sizing: border-box;
            padding: 20px;
            padding-bottom: 0;
            width: 320px;
            // height: 360px;
            border-radius: 5px;
            .creatPeople {
              font-size: 16px;
              font-weight: 400;
              color: #128bf1;
              display: flex;
              align-items: center;
            }
            .headerBox {
              width: 100%;
              display: flex;
              flex-wrap: wrap;
              box-sizing: border-box;
              padding: 0 10px;
              padding-top: 20px;
              .ceatPeopleInfo {
                width: 50%;
                display: flex;
                padding-bottom: 20px;
                align-items: center;
                img {
                  width: 46px;
                  height: 46px;
                  border-radius: 23px;
                }
                img:nth-child(odd) {
                  margin-left: 0;
                }
                span {
                  display: inline-block;
                  width: 70px;
                  overflow: hidden; /*超出部分隐藏*/
                  white-space: nowrap; /*不换行*/
                  text-overflow: ellipsis; /*超出部分文字以...显示*/
                  font-size: 14px;
                  color: #666666;
                  margin-left: 11px;
                }
              }
            }
            .creatPeople::before {
              content: '';
              display: block;
              width: 2px;
              height: 14px;
              background-color: #40a0f2;
              margin-right: 10px;
            }
            .border-up-empty::after {
              content: '';
              position: absolute;
              left: 310px;
              top: 20px;
              width: 0;
              height: 0px;
              border-style: solid;
              border-width: 10px;
              border-color: #fff #fff transparent transparent;
              transform: rotate(-315deg);
              box-shadow: 3px -3px 3px rgba(0, 0, 0, 0.11);
            }
          }
        }
        .headerLogo {
          width: 46px;
          height: 46px;
          border-radius: 50%;
          margin-left: 10px;
        }
      }
      .tableBodyItem:hover {
        box-shadow: 0px 0px 9px 0px rgba(3, 70, 126, 0.14);
        .projectItemTitle {
          color: #128bf1;
        }
      }
      .tableBodyItem:hover .starIcon {
        display: block !important;
      }
    }
    // 分页行
    .pageRow {
      height: 20px;
      box-sizing: border-box;
      margin-top: 10px;
      width: 100%;
      height: 50px;
      display: flex;
      justify-content: flex-end;
      /deep/.el-pagination .el-select .el-input .el-input__inner {
        font-size: 14px;
      }
      /deep/.el-pagination button,
      /deep/.el-pagination span:not([class*='suffix']) {
        font-size: 14px;
      }
    }
  }
}
.table__body::-webkit-scrollbar {
  width: 5px !important;
}
.table__body::-webkit-scrollbar-track {
  -webkit-box-shadow: inset006pxrgba(0, 0, 0, 0.3);
  border-radius: 10px;
}
/* 滚动条滑块 */
.table__body::-webkit-scrollbar-thumb {
  border-radius: 10px;
  background: rgba(0, 0, 0, 0.1);
  -webkit-box-shadow: inset006pxrgba(0, 0, 0, 0.5);
}
</style>